<template lang="pug">
v-card.mb-3
  v-card-text
    template(v-if="!edit")
      v-data-table(:items="fodynModels" :headers="headers" :loading="$apollo.queries.fodynModels.loading" must-sort :pagination.sync="pagination")
        template(slot="items" slot-scope="{item}")
          td {{item.name}}
          td {{item.table}}
          td.text-xs-right: v-btn(icon @click="startEdit(item)"): v-icon edit
      v-btn(@click="addModel()") <v-icon left>add</v-icon> Model Hinzufügen
    template(v-else)
      v-layout(row wrap)
        v-flex(xs12 sm6): v-text-field(label="Name" v-model="edit.name" disabled)
        v-flex(xs12 sm6): v-text-field(label="Tabelle" v-model="edit.table" disabled)
      v-tabs(v-model="activeTab" xcolor="cyan" xdark xslider-color="yellow")
        v-tab Seiten
        v-tab-item
          v-data-table(:items="fodynModelPages" :headers="headersPage" :rows-per-page-items="[-1]" hide-actions must-sort)
            template(slot="items" slot-scope="{item}")
              tr
                td {{item.name}}
                td {{item.slug}}
                td {{item.type}}
                td.text-xs-right: v-btn(icon @click="startEditPage(item)"): v-icon edit
          v-btn(@click="addPage()") <v-icon left>add</v-icon> Seite Hinzufügen

        v-tab Spalten
        v-tab-item
          v-data-table(:items="edit.columns" :headers="headersColumn" :rows-per-page-items="[-1]" hide-actions must-sort)
            template(slot="items" slot-scope="{item}")
              tr(:class="item.deleted ? `error` : ''")
                td {{item.name}}
                td {{item.type}}
                td {{item.nullable ? 'Ja' : 'Nein'}}
                td
                  .grey--text(v-if="item.default === null") NULL
                  template(v-else) {{item.default}}
                td.text-xs-right: v-btn(icon @click="startEditColumn(item)"): v-icon edit
          v-btn(@click="addColumn(columnTypes[0])") <v-icon left>add</v-icon> Spalte Hinzufügen

  v-card-actions(v-if="edit")
    template(v-if="activeTab === 1")
      v-btn(outline @click="save()" color="primary") Speichern
      v-btn(outline @click="cancelEdit()") Abbrechen
    template(v-else)
      v-btn(outline @click="cancelEdit()") Schliessen

  v-dialog(:value="!!editModel" persistent)
    v-container.pa-0(grid-list-xl fluid)
      v-card.ma-0(v-if="editModel")
        v-card-text
          v-form
            v-layout(wrap)
              v-flex(xs12 md6): v-text-field(label="Model Name" v-model="editModel.name" :error-messages="gqlErrorsFor('fodynModelCreate', 'name')")
              v-flex(xs12 md6): v-text-field(label="Tabelle" v-model="editModel.table" :error-messages="gqlErrorsFor('fodynModelCreate', 'table')")
        v-card-actions
          v-btn(outline @click="createModel()" color="primary") Speichern
          v-btn(outline @click="cancelModel()") Abbrechen

  v-dialog(:value="!!editColumn" persistent)
    v-container.pa-0(grid-list-xl fluid)
      v-card.ma-0(v-if="editColumn")
        v-card-text
          v-form(ref="formColumn")
            v-layout(row wrap)
              v-flex(xs12 sm6): v-text-field(label="Spalten Name" v-model="editColumn.name" :rules="[required, validColumnName]")
              v-flex(xs12 sm6): v-select(label="Art" v-model="editColumn.type" :items="columnTypes" item-text="name" item-value="type")
              v-flex(xs12 sm6): v-checkbox(label="NULL Zulassen" v-model="editColumn.nullable")
              v-flex(xs12 sm6)
                v-checkbox(v-if="editColumn.default === null" label="Default Wert" :input-value="editColumn.default" @change="editColumn.default = ''" :rules="[editColumnNotNullable]")
                v-text-field(v-else label="Default Wert" v-model="editColumn.default" append-icon="clear" @click:append="editColumn.default = null")
        v-card-actions
          v-btn(outline @click="saveEditColumn()" color="primary") Übernehmen
          v-btn(outline @click="cancelEditColumn()") Abbrechen
          v-spacer
          v-btn(outline @click="deleteEditColumn()") {{ editColumn.deleted ? 'Behalten' : 'Löschen' }}

  v-dialog(:value="!!editPage" persistent)
    v-container.pa-0(grid-list-xl fluid)
      v-card.ma-0(v-if="editPage")
        v-card-text
          v-form(ref="formPage")
            v-layout(row wrap)
              v-flex(xs12 md4): v-text-field(label="Seitenname" v-model="editPage.name" :rules="[required]" :error-messages="gqlErrorsFor('fodynModelPageUpsert', 'name')")
              v-flex(xs12 sm6 md4): v-text-field(label="Slug" v-model="editPage.slug" :rules="[required, validPageSlug]" :error-messages="gqlErrorsFor('fodynModelPageUpsert', 'slug')")
              v-flex(xs12 sm6 md4): v-select(label="Art" v-model="editPage.type" :disabled="!!editPage.id" :items="pageTypes" item-text="name" item-value="type" :rules="[required]" :error-messages="gqlErrorsFor('fodynModelPageUpsert', 'type')")
              v-flex(xs12 sm6): radio-group(label="Modus" row v-model="showEditBox" :items="[{ text: 'Vorschau', value: null }, { text: 'Rahmen', value: false }, { text: 'Bearbeiten', value: 'level' }]")
              v-flex(xs12 v-if="showEditBox === 'level'"): v-btn(@click="addGroup(-1, { children: groups })") <v-icon left>add</v-icon> Gruppe
              v-flex(xs12)
                layout-tree(:value="{ children: groups }" :border="showEditBox !== null")
                  template(slot-scope="{ item, itemI, parent, depth }")
                    div(v-if="showEditBox")
                      v-menu(left top offset-y)
                        template(v-slot:activator="{ on }")
                          v-btn(v-on="on" block color="grey lighten-2"): .text-truncate {{depth}}-{{itemI}} {{item.widths.join(" ")}}
                        v-list
                          v-list-tile(@click="removeGroup(itemI, parent)") <v-icon left>delete</v-icon> Gruppe
                          v-list-tile(@click="addGroup(itemI, parent, item.widths)") <v-icon left>add</v-icon> Gruppe
                          v-list-tile(@click="moveGroup(itemI, -1, parent)") <v-icon left>arrow_left</v-icon> Gruppe
                          v-list-tile(@click="moveGroup(itemI, 1, parent)") <v-icon left>arrow_right</v-icon> Gruppe
                          v-list-tile(@click="addGroup(-1, item)") <v-icon left>add</v-icon> UnterGruppe
                          v-list-tile(@click="startEditElement(addElement(-1, item))") <v-icon left>add</v-icon> Element
                          v-list-tile(@click.stop=""): v-combobox(single-line hide-details label="Breiten" v-model="item.widths" multiple :items="['xs12', 'sm6', 'md4', 'lg3', 'offset-xs0', 'order-xs1']")
                          //- v-list-tile(@click.stop=""): v-select(single-line hide-details label="Flex" v-model="item.containerFlex" :items="[{ text: 'no', value: null }, { text: 'flex', value: true }, { text: 'cont', value: false }]")
                    template(v-if="showEditBox === 'level'")
                      template(v-for="field, fieldI in item.fields")
                        div
                          v-menu(left offset-y)
                            template(v-slot:activator="{ on }")
                              v-btn(v-on="on" block): .text-truncate {{fieldLabelOrType(field)}}
                            v-list
                              v-list-tile(@click="startEditElement(field)") <v-icon left>edit</v-icon> Element
                              v-list-tile(@click="startEditElement(addElement(fieldI, item))") <v-icon  left>add</v-icon> Element
                              v-list-tile(@click="moveElement(fieldI, -1, item)") <v-icon left>arrow_drop_up</v-icon> Element
                              v-list-tile(@click="moveElement(fieldI, 1, item)") <v-icon left>arrow_drop_down</v-icon> Element
                              v-list-tile(@click="removeElement(fieldI, item)") <v-icon left>delete</v-icon> Element

                    template(v-else)
                      template(v-for="field in item.fields")
                        div(@click.ctrl="startEditElement(field)" :class="field.type === 'v-btn' ? 'd-inline-block' : ''")
                          extra-fodyn-field(:values="editPage.values" :field="field" :model="edit" :status="fieldStatus")
                          .grey--text.text-truncate(v-if="field.type === null") {{fieldLabelOrType(field)}}

        v-card-actions
          v-btn(outline @click="saveEditPage()" color="primary") Speichern
          v-btn(outline @click="cancelEditPage()") Abbrechen
          v-spacer
          v-btn(outline @click="deleteEditPage()") {{ editPage.deleted ? 'Behalten' : 'Löschen' }}

  v-dialog(:value="!!editElement" persistent)
    v-container.pa-0(grid-list-xl fluid)
      v-card.ma-0(v-if="editElement")
        v-card-text
          v-form(ref="formElement")
            v-layout(row wrap)
              v-flex(xs12 sm6): v-select(label="Spalte" clearable @input="editElement.type = null" v-model="editElement.columnId" :items="edit.columns" item-text="name" item-value="id")
              v-flex(xs12 sm6): v-select(label="Art" v-model="editElement.type" :items="fieldTypesFor(editElement)" item-text="name" item-value="type")
              v-flex(xs12 v-if="fieldHas(editElement, 'labelHtml')"): tiptap-input(label="Text" v-model="editElement.label")
              v-flex(xs12 sm6 v-if="fieldHas(editElement, 'label')"): v-text-field(label="Label" v-model="editElement.label")
              v-flex(xs12 sm6 v-if="fieldHas(editElement, 'hint')"): v-text-field(label="Hint" v-model="editElement.hint")
              v-flex(xs12 sm6 v-if="fieldHas(editElement, 'color')"): v-text-field(label="Farbe" v-model="editElement.color")
              v-flex(xs12 sm6 v-if="editElement.type === 'v-btn'"): v-Select(label="Art" v-model="editElement.subtype" :items="[{ text: 'Submit', value: 'submit' }, { text: 'Reset', value: 'reset' }]")
              v-flex(xs12)
                v-checkbox(v-if="fieldHas(editElement, 'clearable')" label="Clearable" v-model="editElement.clearable" hide-details)
                v-checkbox(v-if="fieldHas(editElement, 'persistentHint')" label="Persistenter Hint" v-model="editElement.persistentHint" hide-details)
                v-checkbox(v-if="fieldHas(editElement, 'hideDetails')" label="Hint Verstecken" v-model="editElement.hideDetails" hide-details)
                v-select(v-if="fieldHas(editElement, 'columns')" v-model="editElement.columnIds" :items="edit.columns" multiple item-text="name" item-value="id")

              v-flex(xs12 v-if="editElement.columnId")
                v-menu(left offset-y)
                  template(v-slot:activator="{ on }")
                    v-btn(v-on="on"): <v-icon left>add</v-icon> Validation
                  template(v-if="edit.validations.some((v) => editElement.validationIds.indexOf(v.id) < 0)")
                    v-list
                      template(v-for="validation in validationsFor(editElement, edit.validations)")
                        v-list-tile(@click="startEditValidation(validation.id, true)") <v-icon left>add</v-icon> {{validationLabel(validation)}}
                    v-divider.grey
                  v-list
                    template(v-for="validationType in validationTypesFor(editElement)")
                      v-list-tile(@click="startEditValidation(addNewValidation(validationType))") <v-icon left>add</v-icon> {{validationType.name}}
                template(v-for="validation in editElementValidations")
                  v-btn(@click="startEditValidation(validation.id)"): <v-icon left>edit</v-icon> {{validationLabel(validation)}}

              v-flex(xs12 @click="")
                v-btn(@click="addCondition"): <v-icon left>add</v-icon> Condition
                br
                template(v-for="condition in editElement.conditions")
                  v-btn(@click="startEditCondition(condition)")
                    <v-icon left>edit</v-icon>
                    |  {{condition.action}} if {{columnName(condition.columnId)}} {{condition.type}} {{condition.value}}

        v-card-actions
          v-btn(outline @click="cancelEditElement()") Schliessen

  v-dialog(:value="!!editValidation" persistent)
    v-container.pa-0(grid-list-xl fluid)
      v-card.ma-0(v-if="editValidation")
        v-card-text
          v-form(ref="formValidation")
            v-layout(wrap)
              v-flex(xs12): v-text-field(label="Name" v-model="editValidation.name")
              template(v-if="editValidation.type === 'in'")
                v-flex(xs12): v-combobox(label="Werte" v-model="editValidation.values" chips multiple)
              template(v-if="editValidation.type === 'numericality'")
                v-flex(xs12 sm6): v-text-field(label="Min" v-model="editValidation.min")
                v-flex(xs12 sm6): v-text-field(label="Max" v-model="editValidation.max")
              template(v-if="editValidation.type === 'length'")
                v-flex(xs12 sm6): v-text-field(label="Min" v-model="editValidation.min")
                v-flex(xs12 sm6): v-text-field(label="Max" v-model="editValidation.max")
              template(v-if="editValidation.type === 'format'")
                v-flex(xs12): v-text-field(label="RegExp" v-model="editValidation.regex")
        v-card-actions
          v-btn(outline @click="cancelEditValidation()") Schliessen
          v-spacer
          v-btn(outline @click="deleteEditValidation()") Löschen

  v-dialog(:value="!!editCondition" persistent)
    v-container.pa-0(grid-list-xl fluid)
      v-card.ma-0(v-if="editCondition")
        v-card-text
          v-form(ref="formCondition")
            v-layout(wrap)
              v-flex(xs12): v-select(label="Aktion" v-model="editCondition.action" :items="conditionActions")
              v-flex(xs12): v-select(label="Spalte" v-model="editCondition.columnId" :items="edit.columns" item-text="name" item-value="id")
              v-flex(xs12): v-select(label="Operator" v-model="editCondition.type" :items="conditionTypes")
              v-flex(xs12): v-text-field(label="Wert" v-model="editCondition.value")
        v-card-actions
          v-btn(outline @click="cancelEditCondition()") Schliessen
          v-spacer
          v-btn(outline @click="deleteEditCondition()") Löschen

</template>

<script>
import gql from 'graphql-tag'
import uuidv4 from 'uuid/v4'
import LayoutTree from '../layout-tree'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import ExtraFodynField from './extra-fodyn-field'

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  components: {
    LayoutTree,
    ExtraFodynField,
  },
  data() {
    return {
      showEditBox: null,
      loading: 0,
      activeTab: null,
      editModel: null,
      edit: null,
      editColumn: null,
      editPage: null,
      editGroup: null,
      editElement: null,
      editValidation: null,
      editCondition: null,
      conditionActions: [
        { text: "Hide", value: "hide" },
        { text: "Show", value: "show" },
      ],
      conditionTypes: [
        { text: "Gleich", value: "eq" },
        { text: "Ungleich", value: "neq" },
        { text: "Grösser", value: "gt" },
        { text: "Kleiner", value: "lt" },
        { text: "Wahr", value: "truthy" },
        { text: "Unwahr", value: "falsy" },
      ],
      fieldStatus: {
        loading: false,
        success: false,
        error: true,
        errors: { "": [] },
      },
      groups: [],
      pagination: {
        rowsPerPage: -1
      },
      fodynModels: [],
      fodynModelPages: [],
      headers: [
        { text: "Name", value: "name" },
        { text: "Tabelle", value: "table" },
        { text: "", sortable: false },
      ],
      headersColumn: [
        { text: "Spaltenname", value: "name" },
        { text: "Art", value: "type" },
        { text: "NULL", value: "nullable" },
        { text: "Default", value: "default" },
        { text: "", sortable: false },
      ],
      headersPage: [
        { text: "Name", value: "name" },
        { text: "Slug", value: "slug" },
        { text: "Art", value: "type" },
        { text: "", sortable: false },
      ],
      columnTypes: [
        { name: "String", type: "string" },
        { name: "Text", type: "text" },
        { name: "Boolean", type: "boolean" },
        { name: "Integer", type: "integer" },
        { name: "Decimal", type: "decimal" },
        { name: "Float", type: "float" },
        { name: "DatumZeit", type: "datetime" },
        { name: "Datum", type: "date" },
        { name: "Projekt", type: "projekt" },
      ],
      pageTypes: [
        { name: "Formular", type: "form" },
        { name: "Index", type: "index" },
      ],
      validationTypes: [
        { name: "Präsenz",     type: "presence",     columnTypes: ['string', 'text', 'boolean', 'integer', 'decimal', 'float', 'datetime', 'date', 'projekt'] },
        { name: "Liste",       type: "in",           columnTypes: ['string', 'text', 'boolean', 'integer', 'decimal', 'float', 'datetime', 'date'] },
        { name: "Numerizität", type: "numericality", columnTypes: ['integer', 'decimal', 'float'] },
        { name: "Länge",       type: "length",       columnTypes: ['string', 'text'] },
        { name: "Format",      type: "format",       columnTypes: ['string', 'text'] },
      ],
      fieldTypes: [
        { name: "Text Feld",      type: "v-text-field",      columnTypes: ['string', 'text', 'integer', 'decimal', 'float'],                                           has: { kinds: ['form'],          label: true,  labelHtml: false, clearable: true,  hint: true,  persistentHint: true,  hideDetails: true,  color: false, columns: false } },
        { name: "Text Area",      type: "v-textarea",        columnTypes: ['text'],                                                                                    has: { kinds: ['form'],          label: true,  labelHtml: false, clearable: true,  hint: true,  persistentHint: true,  hideDetails: true,  color: false, columns: false } },
        { name: "Text Area HTML", type: "tiptap-input",      columnTypes: ['text'],                                                                                    has: { kinds: ['form'],          label: true,  labelHtml: false, clearable: false, hint: false, persistentHint: false, hideDetails: false, color: false, columns: false } },
        { name: "Select",         type: "v-select",          columnTypes: ['string', 'boolean', 'integer', 'decimal', 'float'],                                        has: { kinds: ['form'],          label: true,  labelHtml: false, clearable: true,  hint: true,  persistentHint: true,  hideDetails: true,  color: false, columns: false } },
        { name: "Button",         type: "v-btn",             columnTypes: ['none'],                                                                                    has: { kinds: ['form'],          label: true,  labelHtml: false, clearable: false, hint: false, persistentHint: false, hideDetails: false, color: true,  columns: false } },
        { name: "Checkbox",       type: "v-checkbox",        columnTypes: ['boolean'],                                                                                 has: { kinds: ['form'],          label: true,  labelHtml: false, clearable: false, hint: true,  persistentHint: true,  hideDetails: true,  color: true,  columns: false } },
        { name: "HTML",           type: "html",              columnTypes: ['none'],                                                                                    has: { kinds: ['form', 'index'], label: false, labelHtml: true,  clearable: false, hint: false, persistentHint: false, hideDetails: false, color: false, columns: false } },
        { name: "FehlerMeldung",  type: "errormessage",      columnTypes: ['none'],                                                                                    has: { kinds: ['form', 'index'], label: false, labelHtml: true,  clearable: true,  hint: false, persistentHint: false, hideDetails: false, color: false, columns: false } },
        { name: "ErfolgMeldung",  type: "successmessage",    columnTypes: ['none'],                                                                                    has: { kinds: ['form', 'index'], label: false, labelHtml: true,  clearable: true,  hint: false, persistentHint: false, hideDetails: false, color: false, columns: false } },
        { name: 'Radio Gruppe',   type: 'radio-group',       columnTypes: ['string', 'boolean', 'integer', 'decimal', 'float'],                                        has: { kinds: ['form'],          label: true,  labelHtml: false, clearable: true,  hint: true,  persistentHint: true,  hideDetails: true,  color: true,  columns: false } },
        { name: 'DatumZeit',      type: 'input-datetime',    columnTypes: ['datetime'],                                                                                has: { kinds: ['form'],          label: true,  labelHtml: false, clearable: true,  hint: true,  persistentHint: true,  hideDetails: true,  color: false, columns: false } },
        { name: 'Datum',          type: 'input-date',        columnTypes: ['date'],                                                                                    has: { kinds: ['form'],          label: true,  labelHtml: false, clearable: true,  hint: true,  persistentHint: true,  hideDetails: true,  color: false, columns: false } },
        { name: "Select Projekt", type: "v-select--projekt", columnTypes: ['projekt'],                                                                                 has: { kinds: ['form'],          label: true,  labelHtml: false, clearable: true,  hint: true,  persistentHint: true,  hideDetails: true,  color: false, columns: false } },
        { name: 'Tabelle',        type: 'v-data-table',      columnTypes: ['none'],                                                                                    has: { kinds: ['index'],         label: false, labelHtml: false, clearable: false, hint: false, persistentHint: false, hideDetails: false, color: false, columns: false } },
        { name: 'Tabellenspalte', type: 'table-col',         columnTypes: ['string', 'text', 'boolean', 'integer', 'decimal', 'float', 'datetime', 'date', 'projekt'], has: { kinds: ['index'],         label: true, labelHtml: false,  clearable: false, hint: false, persistentHint: false, hideDetails: false, color: false, columns: false } },
        // { name: 'Geburtstag',     type: 'birthday-picker',   columnTypes: ['date'],                                             has: { label: true,  labelHtml: false, clearable: true,  hint: true,  persistentHint: true,  hideDetails: true,  color: false } },
      ]
    }
  },
  apollo: {
    fodynModels: gql`query ExtraFodynBuilderVueFodynModels {
      fodynModels {
        id
        name
        table
        usePaperTrail
        columns {
          id
          name
          type
          nullable
          default
          deleted
        }
        validations {
          id
          name
          type
          regex
          min
          max
          values
        }
        pages {
          id
        }
      }
    }`,
    fodynModelPages: {
      query: gql`query ExtraFodynBuilderVueFodynModelPages($ids: [ID!]) {
        fodynModelPages(where: { idIn: $ids }) {
          id
          name
          slug
          type
          groups {
            id
            widths
            containerFlex
            parentId
            fields {
              id
              columnId
              type
              label
              labelHtml
              clearable
              hint
              persistentHint
              hideDetails
              color
              subtype
              # groupId
              validationIds
              columnIds
              conditions {
                action
                type
                columnId
                value
              }
            }
          }
        }
      }`,
      variables() {
        return {
          ids: this.edit && this.edit.pages.map((p) => p.id)
        }
      },
      skip() {
        return !this.edit
      }
    }
  },
  computed: {
    compatibleColumns() {
      if (this.editColumn) {
        const column_type = this.editColumn.type
        return this.columnTypes.filter((type) => type.type === column_type)
      } else {
        return []
      }
    },
    fieldTypeHas() {
      let has = {}
      this.fieldTypes.forEach((field) => {
        has[field.type] = field.has
      })
      return has
    },
    fieldTypeHash() {
      let types = {}
      this.fieldTypes.forEach((field) => {
        types[field.type] = field
      })
      return types
    },
    editElementValidations() {
      let editElement = this.editElement
      if (editElement) {
        const validations = this.edit.validations
        return editElement.validationIds.map((id) => validations.find((v) => id === v.id) || { id: id, notFound: true })
      } else {
        return []
      }
    }
  },
  methods: {
    selectItemsFor(field) {
      const validationIds = field.validationIds
      const validation = this.edit.validations.find((v) => validationIds.indexOf(v.id) > -1)
      return validation && validation.values || []
    },
    required(v) {
      return !!v || 'muss ausgefüllt werden'
    },
    editColumnNotNullable(_v) {
      return this.editColumn.nullable ? true : 'kann nicht NULL sein wenn NULL nicht Zulgelassen ist'
    },
    validColumnName(v) {
      if (!/^[a-z][a-z0-9_]*$/.test(v)) {
        return 'darf nur kleine buchstaben nummern und unterstriche enthalten'
      } else if (['id', 'created_at', "updated_at"].indexOf(v) >= 0) {
        return 'dieser name ist bereits vergeben'
      }
      if (this.edit && this.edit.columns) {
        const column = this.edit.columns.find((col) => col.name === v)
        if (column && column.id !== this.editColumn.id) {
          return 'dieser name ist bereits vergeben'
        }
      }
      return true
    },
    validPageSlug(v) {
      if (!/^[a-z][a-z0-9-]*[a-z0-9]$/.test(v)) {
        return 'darf nur kleine buchstaben nummern und bindestriche enthalten'
      }
      return true
    },
    addModel() {
      this.editModel = { name: '', table: '' }
    },
    createModel() {
      this.gqlClearAllErrors()
      this.loading++
      this.$apollo.mutate({
        mutation: gql`mutation ExtraFodynBuilderVueCreateModel (
            $name: String
            $table: String
        ) {
          fodynModelCreate (
            name: $name
            table: $table
          ) {
            id
          }
        }`,
        variables: this.editModel
      }).then((response) => {
        this.loading--
        if (response.data.fodynModelCreate.id) {
          this.cancelModel()
          this.$apollo.queries.fodynModels.refetch()
        } else {
          alert('Ein Fehler is aufgetreten.')
        }
      }, (error) => {
        this.loading--
        this.gqlAddErrors(error)
        if (this.gqlErrorsFor('fodynModelCreate', 'name').length + this.gqlErrorsFor('fodynModelCreate', 'table').length == 0) {
          alert('Ein Fehler is aufgetreten.')
        }
      })
    },
    cancelModel() {
      this.editModel = null
    },
    startEdit(item) {
      this.edit = {
        ...item,
        columns: item.columns.map((columns) => ({ ...columns })),
        validations: item.validations.map((val) => ({ ...val })),
      }
    },
    cancelEdit() {
      this.edit = null
    },
    save() {
      this.gqlClearAllErrors()
      this.loading++
      this.$apollo.mutate({
        mutation: gql`mutation ExtraFodynBuilderVueAddColumn (
            $id: ID!
            $columns: [FodynColumnInput]
        ) {
          fodynModelAddColumn (
            id: $id
            columns: $columns
          ) { id }
        }`,
        variables: {
          id: this.edit.id,
          columns: this.edit.columns.map((column) => ({ ...column, isNew: undefined, __typename: undefined })),
        }
      }).then((response) => {
        this.loading--
        if (response.data.fodynModelAddColumn.id) {
          this.cancelEdit(0)
          this.$apollo.queries.fodynModels.refetch()
        } else {
          alert('Ein Fehler is aufgetreten.')
        }
      }, (error) => {
        this.loading--
        this.gqlAddErrors(error)
        alert('Ein Fehler is aufgetreten.')
      })
    },
    startEditColumn(item) {
      this.editColumn = { ...item }
    },
    addColumn(column) {
      this.editColumn = { name: '', type: column.type, id: uuidv4(), isNew: true, nullable: true, default: null, deleted: false }
    },
    cancelEditColumn() {
      this.editColumn = null
    },
    deleteEditColumn() {
      const editColumn = this.editColumn
      if (editColumn.deleted) {
        editColumn.deleted = false
      } else if (confirm(`${this.edit.name}.${editColumn.name} Löschen?`)) {
        const columns = this.edit.columns
        if (editColumn.isNew) {
          const index = columns.findIndex((column) => column.id === editColumn.id)
          if (index >= 0) {
            columns.splice(index, 1)
          }
          this.cancelEditColumn()
        } else {
          editColumn.deleted = true
          this.saveEditColumn()
        }
      }
    },
    saveEditColumn() {
      if (!this.$refs.formColumn.validate()) {
        return
      }
      const editColumn = this.editColumn
      const columns = this.edit.columns
      const index = columns.findIndex((column) => column.id === editColumn.id)
      if (index < 0) {
        columns.push(this.editColumn)
      } else {
        columns.splice(index, 1, editColumn)
      }
      this.editColumn = null
    },
    addPage() {
      this.editPage = { id: null, name: "", slug: "", type: "form" }
    },
    startEditPage(page) {
      const values = {}
      this.edit.columns.forEach((c) => { values[c.id] = null })
      this.editPage = { ...page, values }

      let allGroups = page.groups.map((group) => ({ ...group, children: [] }))
      let roots = []
      allGroups.forEach((group) => {
        if (group.parentId) {
          let parent = allGroups.find((g) => g.id === group.parentId)
          if (parent) {
            parent.children.push(group)
          } else {
            console.error('orphaned group', group)
          }
        } else {
          roots.push(group)
        }
      })
      this.groups = roots
    },
    cancelEditPage() {
      this.editPage = null
      this.groups = []
    },
    deleteEditPage() {
      if (!confirm(`Seite ${this.edit.name}: ${this.editPage.name} Löschen?`)) {
        return
      }

      this.gqlClearAllErrors()
      this.loading++
      this.$apollo.mutate({
        mutation: gql`mutation ExtraFodynBuilderVueDeletePage (
            $id: ID!
        ) {
          fodynModelPageDestroy (
            id: $id
          ) {
            success
          }
        }`,
        variables: {
          id: this.editPage.id,
        }
      }).then((response) => {
        this.loading--
        if (response.data.fodynModelPageDestroy.success) {
          this.cancelEditPage()
          this.$apollo.queries.fodynModels.refetch()
          this.$apollo.queries.fodynModelPages.refetch()
        } else {
          alert('Ein Fehler is aufgetreten.')
        }
      }, (error) => {
        this.loading--
        this.gqlAddErrors(error)
        alert('Ein Fehler is aufgetreten.')
      })
    },
    saveEditPage() {
      if (!this.$refs.formPage.validate()) {
        return
      }

      const newPage = !this.editPage.id
      this.gqlClearAllErrors()
      this.loading++
      this.$apollo.mutate({
        mutation: gql`mutation ExtraFodynBuilderVueUpdatePage (
            $modelId: ID!
            $id: ID
            $name: String
            $slug: String
            $type: String
            $validations: [FodynModelValidationInput]
            $groups: [FodynModelGroupInput]
        ) {
          fodynModelPageUpsert (
            modelId: $modelId
            id: $id
            name: $name
            slug: $slug
            type: $type
            validations: $validations
            groups: $groups
          ) {
            id
            name
            slug
            type
          }
        }`,
        variables: {
          modelId: this.edit.id,
          id: this.editPage.id,
          name: this.editPage.name,
          slug: this.editPage.slug,
          type: this.editPage.type,
          validations: this.edit.validations.map((val) => ({
            ...val,
            min: `${val.min || ''}` || null,
            max: `${val.max || ''}` || null,
            __typename: undefined,
          })),
          groups: this.groups.map((group) => ({
            ...group,
            __typename: undefined,
            parentId: undefined,
            children: undefined,
            widths: group.widths.map((g) => g),
            fields: group.fields.map((field) => ({
              ...field,
              __typename: undefined,
              groupId: undefined,
              validationIds: field.validationIds.map((v) => v),
              conditions: field.conditions.map((c) => ({
                ...c,
                __typename: undefined,
              })),
            })),
          })),
        }
      }).then((response) => {
        this.loading--
        if (response.data.fodynModelPageUpsert.id) {
          this.cancelEditPage()
          if (newPage) {
            this.cancelEdit()
          }
          this.$apollo.queries.fodynModels.refetch()
        } else {
          alert('Ein Fehler is aufgetreten.')
        }
      }, (error) => {
        this.loading--
        this.gqlAddErrors(error)
        alert('Ein Fehler is aufgetreten.')
      })
    },
    addGroup(i, parent, widths = ['xs12']) {
      let groups = parent.children
      groups.splice(i+1, 0, {
        id: uuidv4(),
        widths: widths.map((w) => w),
        containerFlex: null,
        parentId: null,
        children: [],
        fields: []
      })
    },
    moveGroup(i, direction, parent) {
      let groups = parent.children
      if (i + direction < 0 || i + direction >= groups.length) {
        return
      }
      let group = groups.splice(i, 1)[0]
      groups.splice(i + direction, 0, group)
    },
    removeGroup(i, parent) {
      let groups = parent.children
      groups.splice(i, 1)
    },
    addElement(i, group) {
      const element = {
        id: uuidv4(),
        label: '',
        hint: '',
        clearable: null,
        labelHtml: null,
        persistentHint: null,
        hideDetails: null,
        columnId: null,
        color: null,
        subtype: null,
        type: null,
        groupId: group.id,
        validationIds: [],
        conditions: [],
      }
      group.fields.splice(i+1, 0, element)
      return element
    },
    startEditGroup(group) {
      this.editGroup = group
    },
    cancelEditGroup() {
      this.editGroup = null
    },
    startEditElement(element) {
      this.editElement = element
    },
    cancelEditElement() {
      this.editElement = null
    },
    moveElement(i, direction, group) {
      let fields = group.fields
      if (i + direction < 0 || i + direction >= fields.length) {
        return
      }
      let field = fields.splice(i, 1)[0]
      fields.splice(i + direction, 0, field)
    },
    removeElement(i, group) {
      let fields = group.fields
      fields.splice(i, 1)
    },
    fieldHas(field, has) {
      let type = this.fieldTypeHas[field.type]
      if (type) {
        return type[has]
      }
    },
    fieldLabelOrType(field) {
      let type = this.fieldTypeHash[field.type]
      if (type) {
        if (field.label && type.has.label) {
          return field.label
        } else {
          return type.name
        }
      } else {
        return `Unbekannt: ${field.label || field.type}`
      }
    },
    fieldTypesFor(field) {
      let column = this.edit.columns.find((c) => c.id === field.columnId)
      let types = this.fieldTypes
      const pageType = this.editPage.type
      types = types.filter((t) => t.has.kinds.indexOf(pageType) >= 0)
      if (column) {
        types = types.filter((t) => t.columnTypes.indexOf(column.type) > -1)
      } else {
        types = types.filter((t) => t.columnTypes.indexOf('none') > -1)
      }
      return types
    },
    columnName(columnId) {
      const column = this.edit.columns.find((c) => c.id === columnId)
      return column && column.name || ''
    },
    validationsFor(element, validations) {
      const column = this.edit.columns.find((c) => c.id === element.columnId)
      const type = column && column.type
      const types = this.validationTypes
      const validationIds = this.editElement.validationIds
      validations = validations.filter((v) => validationIds.indexOf(v.id) < 0)
      return validations.filter((v) => (types.find((vt) => vt.type === v.type) || { columnTypes: [] }).columnTypes.some((t) => t === type))
    },
    validationTypesFor(element) {
      const column = this.edit.columns.find((c) => c.id === element.columnId)
      const type = column && column.type
      return this.validationTypes.filter((v) => v.columnTypes.some((t) => t === type))
    },
    validationLabel(validation) {
      const type = validation.type
      const vt = this.validationTypes.find((v) => v.type === type)
      if (vt) {
        return validation.name || vt.name
      } else {
        return validation.name || type
      }
    },
    addNewValidation(validationType) {
      const validations = this.edit.validations
      const element = this.editElement
      const validation = {
        id: uuidv4(),
        type: validationType.type,
        min: null,
        max: null,
        regex: null,
        values: null,
      }
      validations.push(validation)
      element.validationIds.push(validation.id)
      return validation.id
    },
    startEditValidation(validationId, addToEditElement = false) {
      const validations = this.edit.validations
      const validation = validations.find((v) => v.id === validationId)
      if (validation) {
        if (addToEditElement && this.editElement.validationIds.indexOf(validationId) < 0) {
          this.editElement.validationIds.push(validationId)
        }
        this.editValidation = validation
      }
    },
    cancelEditValidation() {
      this.editValidation = null
    },
    deleteEditValidation() {
      const validationIds = this.editElement.validationIds
      const i = validationIds.indexOf(this.editValidation.id)
      if (i >= 0) {
        validationIds.splice(i, 1)
      }
      this.cancelEditValidation()
    },
    addCondition() {
      const condition = {
        action: 'hide',
        columnId: null,
        type: 'eq',
        value: null,
      }
      this.editElement.conditions.push(condition)
      this.startEditCondition(condition)
    },
    startEditCondition(condition) {
      this.editCondition = condition
    },
    cancelEditCondition() {
      this.editCondition = null
    },
    deleteEditCondition() {
      const condition = this.editCondition
      const conditions = this.editElement.conditions
      const i = conditions.indexOf(condition)
      if (i >= 0) {
        conditions.splice(i, 1)
      }
      this.cancelEditCondition()
    }
  }
}
</script>
